import Intro from "./components/Intro"
import Menu from "./components/Menu"
import Toggle from "./components/Toggle"
import SwiperJS from "./components/SwiperJS"
import VideoQuery from "./components/VideoQuery"
import CountryPick from "./components/CountryPick"
import MaxHeight from "./components/MaxHeight"

document.addEventListener('DOMContentLoaded', () => {
    let root = {}
    root.intro = new Intro(root)
    root.menu = new Menu(root)
    root.toggle = new Toggle(root)
    root.swiperJS = new SwiperJS(root)
    root.videoQuery = new VideoQuery(root)
    root.countryPick = new CountryPick(root)
    root.maxHeight = new MaxHeight(root)
}, false)
